import { connect } from 'react-redux'

import { trackMassIssueAlertDisplayed } from '../../actions/getHelp'
import { getOtherIssueIneligibleIngrsByRecipeGRMap } from '../../selectors/selectors'
import { RecipeIngredients } from './RecipeIngredients'

const RecipeIngredientsContainer = connect(
  (state) => ({
    otherIssueIneligibleIngrsByRecipeGRMap: getOtherIssueIneligibleIngrsByRecipeGRMap(state),
  }),
  {
    trackMassIssueAlertDisplayed,
  },
)(RecipeIngredients)

export { RecipeIngredientsContainer }
